"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex justify-end" };
const _hoisted_3 = { href: "/./files/usercsvexport/userCsvExport.csv" };
const _hoisted_4 = { class: "btn btn-rounded btn-warning mr-3" };
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-download" }, null, -1);
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_7 = { key: 0 };
const _hoisted_8 = {
    key: 0,
    class: "marso-icon-right text-green"
};
const _hoisted_9 = {
    key: 1,
    class: "marso-icon-wrong text-red"
};
const _hoisted_10 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-pencil" }, null, -1);
const _hoisted_13 = ["onClick"];
const _hoisted_14 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-trash" }, null, -1);
const _hoisted_15 = { class: "input-group my-5" };
const _hoisted_16 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_17 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const Alert_vue_1 = __importDefault(require("../../components/Alert.vue"));
const Form_1 = require("../../components/Form");
const AsyncSearchInputOption_1 = __importDefault(require("../../components/Form/AsyncSearchInput/AsyncSearchInputOption"));
const UserRequest_1 = __importDefault(require("../../stores/user/UserRequest"));
const toastStore_1 = require("../../stores/toast/toastStore");
const userStore_1 = require("../../stores/user/userStore");
const userGroupStore_1 = require("../../stores/userGroup/userGroupStore");
const vue_router_1 = require("vue-router");
const i18n_1 = require("../../common/i18n");
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const ShopConfig_1 = require("../../common/utils/ShopConfig");
const customersStore_1 = require("../../stores/customers/customersStore");
const securityStore_1 = require("../../stores/security/securityStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminUsers',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const router = (0, vue_router_1.useRouter)();
        const userStore = (0, userStore_1.useUserStore)();
        const userGroupStore = (0, userGroupStore_1.useUserGroupStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const customersStore = (0, customersStore_1.useCustomersStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const userAddressesOptions = (0, vue_3.ref)([]);
        const modalIsOpen = (0, vue_3.ref)(false);
        const errorMessage = (0, vue_3.ref)("");
        const userRequest = (0, vue_3.ref)(new UserRequest_1.default());
        const selectedUser = (0, vue_3.ref)(null);
        const sortBy = (0, vue_3.ref)("id");
        const sortDesc = (0, vue_3.ref)(false);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        const plainPasswordConfirmation = (0, vue_3.ref)("");
        const customerAsyncSearchInput = (0, vue_3.ref)(null);
        const selectedAddressId = (0, vue_3.ref)(null);
        const shopLocation = ShopConfig_1.ShopConfig.getShopLocation();
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_a = (0, i18n_1.trans)("id", "ID", "users")) !== null && _a !== void 0 ? _a : "ID",
                value: "id",
                sortable: true,
                filterable: true,
            },
            {
                key: "email",
                label: (_b = (0, i18n_1.trans)("email", "Email", "users")) !== null && _b !== void 0 ? _b : "Email",
                value: "email",
                filterable: true,
                sortable: true,
            },
            {
                key: "customer.customerName",
                label: (_c = (0, i18n_1.trans)("customer", "Customer", "users")) !== null && _c !== void 0 ? _c : "Customer",
                value: "customer.customerName",
                filterable: true,
                sortable: true,
            },
            {
                key: "lastTimeLogged",
                label: (_d = (0, i18n_1.trans)("last_time_logged", "Last time logged", "users")) !== null && _d !== void 0 ? _d : "Last time logged",
                value: "lastTimeLogged",
                sortable: true,
                filterable: true,
            },
            {
                key: "isActive",
                label: (_e = (0, i18n_1.trans)("active", "Active", "users")) !== null && _e !== void 0 ? _e : "Active",
                value: "isActive",
                sortable: true,
                filterable: false,
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const userGroupsListFields = (0, vue_3.ref)([
            {
                key: "name",
                label: (_f = (0, i18n_1.trans)("user_group", "User Group", "users")) !== null && _f !== void 0 ? _f : "User Group",
                value: "name",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const userQuery = (0, vue_3.computed)(() => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            let order = `order[${sortBy.value}]`;
            return {
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                [order]: sortDesc.value ? "desc" : "asc",
                ...filters,
            };
        });
        (0, vue_3.onBeforeUnmount)(() => {
            userStore.reset();
        });
        (0, vue_3.onBeforeMount)(() => {
            userStore
                .getUsers(router, userQuery.value)
                .catch((error) => toastStore.addErrorToast(error.toString()));
            userGroupStore
                .getUserGroups(router)
                .catch((error) => toastStore.addErrorToast(error.toString()));
        });
        (0, vue_3.watch)(userQuery, () => {
            userStore
                .getUsers(router, userQuery.value)
                .catch((error) => toastStore.addErrorToast(error.toString()));
        });
        const openCreateUserModal = () => {
            userRequest.value = new UserRequest_1.default();
            selectedUser.value = null;
            modalIsOpen.value = true;
            userAddressesOptions.value = [];
        };
        const openUpdateUserModal = (user) => {
            var _a, _b;
            selectedUser.value = user;
            userRequest.value = new UserRequest_1.default(null, user.email, user.customer ? user.customer["@id"] : '', (_a = user.defaultAddress) === null || _a === void 0 ? void 0 : _a["@id"], user.groups.map((userGroup) => userGroup["@id"]), user.department, user.extraEmails, user.isActive);
            (0, vue_3.nextTick)(() => {
                var _a;
                if (user.customer) {
                    (_a = customerAsyncSearchInput.value) === null || _a === void 0 ? void 0 : _a.setDisplayValue(`${user.customer.customerName} - ${user.customer.id}`);
                }
            });
            modalIsOpen.value = true;
            selectedAddressId.value = ((_b = user.defaultAddress) === null || _b === void 0 ? void 0 : _b["@id"]) || null;
            setSelectedAddress(userAddressesOptions.value, user);
        };
        const deleteUser = (user) => {
            if (!confirm((0, i18n_1.trans)("delete_user_confirm", "Are you sure?", "users"))) {
                return;
            }
            errorMessage.value = "";
            userStore
                .deleteUser(router, user.id)
                .then(() => {
                userStore.reset();
                userStore
                    .getUsers(router, userQuery.value)
                    .catch((error) => toastStore.addErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addErrorToast(error.toString()));
        };
        const createUser = () => {
            var _a;
            errorMessage.value = "";
            if (userRequest.value.plainPassword !== plainPasswordConfirmation.value) {
                errorMessage.value =
                    (_a = (0, i18n_1.trans)("passwords_not_match", "Given password and the confirmation does not match.", "users")) !== null && _a !== void 0 ? _a : "Given password and the confirmation does not match";
                return;
            }
            userStore
                .createUser(router, userRequest.value)
                .then(() => {
                modalIsOpen.value = false;
                userStore.reset();
                page.value = 1;
                userStore
                    .getUsers(router, userQuery.value)
                    .catch((error) => toastStore.addErrorToast(error.toString()));
            })
                .catch((error) => toastStore.addErrorToast(error.toString()));
        };
        const updateUser = async () => {
            var _a, _b;
            errorMessage.value = "";
            if (userRequest.value.plainPassword !== null &&
                userRequest.value.plainPassword !== "" &&
                userRequest.value.plainPassword !== plainPasswordConfirmation.value) {
                errorMessage.value =
                    (_a = (0, i18n_1.trans)("passwords_not_match", "Given password and the confirmation does not match.", "users")) !== null && _a !== void 0 ? _a : "Given password and the confirmation does not match";
                return;
            }
            if (selectedUser.value === null) {
                errorMessage.value =
                    (_b = (0, i18n_1.trans)("user_not_selected", "User not selected", "users")) !== null && _b !== void 0 ? _b : "User not selected";
                return;
            }
            if (userRequest.value.plainPassword === "") {
                userRequest.value.plainPassword = null;
            }
            await userStore.updateUser(router, userRequest.value, selectedUser.value.id);
            modalIsOpen.value = false;
            userStore.reset();
            page.value = 1;
            await userStore.getUsers(router, userQuery.value);
            await securityStore.refreshToken(router);
            await securityStore.checkAuth(router);
        };
        (0, vue_3.watch)(modalIsOpen, (value) => {
            if (!value) {
                errorMessage.value = "";
            }
        });
        const userGroupCheckboxChange = (checked, userGroup) => {
            if (!checked) {
                userRequest.value.groups = userRequest.value.groups.filter((userGroupIri) => userGroupIri !== userGroup["@id"]);
                return;
            }
            let userGroupIri = userGroup["@id"];
            if (userGroupIri === undefined) {
                return;
            }
            userRequest.value.groups.push(userGroupIri);
        };
        const customerOptions = (0, vue_3.computed)(() => customersStore.customers.map((customer) => new AsyncSearchInputOption_1.default(`${customer.customerName} - ${customer.id}`, customer["@id"])));
        const customerSearchedValueChanged = async (customerSearchedValue) => {
            customersStore.reset();
            let payload = {
                page: 1,
                itemsPerPage: 5,
            };
            // román customer azonosító CL-el keződődik, az IT-2217 feladat miatt kellett ezt bevezetni
            const regex_customerId_RO = /^CL\d/i;
            do {
                if (shopLocation == "ROU" && regex_customerId_RO.test(customerSearchedValue)) {
                    // Ha a localCode románia, és a mező értéke megfelel a regex-nek, akkor ID alapján keressünk
                    payload["id"] = customerSearchedValue;
                    payload["order[id]"] = "asc";
                    break;
                }
                if (!isNaN(Number(customerSearchedValue))) {
                    payload["id"] = customerSearchedValue;
                    payload["order[id]"] = "asc";
                    break;
                }
                payload["customerName"] = customerSearchedValue;
                payload["order[customerName]"] = "asc";
                // eslint-disable-next-line no-constant-condition
            } while (false);
            try {
                await customersStore.getCustomers(router, payload);
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const customerSelected = (value) => {
            customersStore.reset();
            userRequest.value.customer = value.value;
        };
        const userGroupChecked = (userGroup) => {
            let userGroupIri = userGroup["@id"];
            if (userGroupIri === undefined) {
                return false;
            }
            return userRequest.value.groups.includes(userGroupIri);
        };
        const setSelectedAddress = (userAddressesOptions, user) => {
            const selectedOption = userAddressesOptions.find((option) => { var _a; return option.value === ((_a = user.defaultAddress) === null || _a === void 0 ? void 0 : _a["@id"]); });
            userAddressesOptions.forEach((option) => {
                option.selected = false;
            });
            if (selectedOption) {
                selectedOption.selected = true;
            }
        };
        const getCustomerAddresses = async (id) => {
            try {
                const customer = await customersStore.getCustomer(router, id);
                if (customer && customer["@type"] === "Customer") {
                    const newOptions = customer.addresses.map((customerAddress) => {
                        return new Option_1.default(customerAddress["@id"], `${customerAddress.name} ${customerAddress.zip} ${customerAddress.city} ${customerAddress.street}`, false);
                    });
                    userAddressesOptions.value = newOptions;
                    if (userAddressesOptions.value.length &&
                        selectedAddressId.value) {
                        userAddressesOptions.value.forEach((option) => {
                            if (option.value === selectedAddressId.value) {
                                option.selected = true;
                            }
                        });
                    }
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        (0, vue_3.watch)(() => userRequest.value.customer, (newCustomer) => {
            var _a;
            if (newCustomer) {
                const customerId = newCustomer.split("/").pop();
                if (customerId) {
                    getCustomerAddresses(customerId);
                }
                if (newCustomer !== ((_a = selectedUser.value) === null || _a === void 0 ? void 0 : _a.customer["@id"])) {
                    userRequest.value.defaultAddress = null;
                }
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("a", _hoisted_3, [
                        (0, vue_2.createElementVNode)("button", _hoisted_4, [
                            _hoisted_5,
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("get_users_csv", "Export users", "users")), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary",
                        onClick: _cache[0] || (_cache[0] = ($event) => (openCreateUserModal()))
                    }, [
                        _hoisted_6,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_user_button", "Add User", "users")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[1] || (_cache[1] = ($event) => ((listFields).value = $event)),
                    items: (0, vue_2.unref)(userStore).users,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: (0, vue_2.unref)(userStore).loading,
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[2] || (_cache[2] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[3] || (_cache[3] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[5] || (_cache[5] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: (0, vue_2.unref)(userStore).totalUsers
                }, {
                    "cell-lastTimeLogged": (0, vue_2.withCtx)(({ item: user }) => [
                        (user.lastTimeLogged)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.d)(new Date(user.lastTimeLogged), "iso")), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    "cell-isActive": (0, vue_2.withCtx)(({ item: user }) => [
                        (user.isActive)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_8))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_9))
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: user }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary btn-link",
                                onClick: ($event) => (openUpdateUserModal(user))
                            }, [
                                _hoisted_12,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("edit", "Edit", "users")), 1)
                            ], 8, _hoisted_11),
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link",
                                onClick: ($event) => (deleteUser(user))
                            }, [
                                _hoisted_14,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delete", "Delete", "users")), 1)
                            ], 8, _hoisted_13)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    title: selectedUser.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('edit_user_modal_title', 'Edit User: {user}', 'users', { user: selectedUser.value.email })
                        : (0, vue_2.unref)(i18n_1.trans)('add_user', 'Add User', 'users'),
                    onClose: _cache[15] || (_cache[15] = ($event) => (modalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (errorMessage.value.length)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                                key: 0,
                                title: (0, vue_2.unref)(i18n_1.trans)('save_error', 'Save error', 'users'),
                                message: errorMessage.value
                            }, null, 8, ["title", "message"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('user_email_placeholder', 'User Email', 'users'),
                            label: (0, vue_2.unref)(i18n_1.trans)('user_email_label', 'User Email', 'users'),
                            type: "email",
                            autofocus: "",
                            required: "",
                            modelValue: userRequest.value.email,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((userRequest.value.email) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('password_placeholder', 'Password', 'users'),
                            label: (0, vue_2.unref)(i18n_1.trans)('password_label', 'Password', 'users'),
                            type: "password",
                            required: "",
                            autocomplete: false,
                            modelValue: userRequest.value.plainPassword,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((userRequest.value.plainPassword) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('password_repeat_placeholder', 'Password repeat', 'users'),
                            label: (0, vue_2.unref)(i18n_1.trans)('password_repeat_label', 'Password repeat', 'users'),
                            type: "password",
                            required: "",
                            autocomplete: false,
                            modelValue: plainPasswordConfirmation.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((plainPasswordConfirmation).value = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.AsyncSearchInput), {
                                ref_key: "customerAsyncSearchInput",
                                ref: customerAsyncSearchInput,
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_placeholder', 'Customer', 'users'),
                                label: (0, vue_2.unref)(i18n_1.trans)('customer_label', 'Customer', 'users'),
                                border: "",
                                onSearchedValueChanged: customerSearchedValueChanged,
                                onSelected: customerSelected,
                                options: (0, vue_2.unref)(customerOptions)
                            }, null, 8, ["placeholder", "label", "options"])
                        ]),
                        (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                            modelValue: userRequest.value.defaultAddress,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((userRequest.value.defaultAddress) = $event)),
                            label: (0, vue_2.unref)(i18n_1.trans)('user_default_shipping_address_label', 'Default Shipping Address', 'users'),
                            "placeholder-enable": true,
                            class: "mb-5",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('default_shipping_address', '-- Select default shipping address --', 'users'),
                            options: userAddressesOptions.value
                        }, null, 8, ["modelValue", "label", "placeholder", "options"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.TagInput), {
                            modelValue: userRequest.value.extraEmails,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((userRequest.value.extraEmails) = $event)),
                            "input-type": "email",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('extra_email_addresses', 'Extra email addresses', 'users'),
                            label: (0, vue_2.unref)(i18n_1.trans)('extra_email_addresses_label', 'Extra email addresses', 'users')
                        }, null, 8, ["modelValue", "placeholder", "label"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('department_placeholder', 'Department', 'users'),
                            label: (0, vue_2.unref)(i18n_1.trans)('department_label', 'Department', 'users'),
                            modelValue: userRequest.value.department,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((userRequest.value.department) = $event)),
                            class: "my-5",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            modelValue: userRequest.value.isActive,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((userRequest.value.isActive) = $event)),
                            checked: userRequest.value.isActive,
                            label: (0, vue_2.unref)(i18n_1.trans)('active', 'Active', 'users'),
                            class: "whitespace-nowrap"
                        }, null, 8, ["modelValue", "checked", "label"]),
                        (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                            fields: userGroupsListFields.value,
                            "onUpdate:fields": _cache[13] || (_cache[13] = ($event) => ((userGroupsListFields).value = $event)),
                            items: (0, vue_2.unref)(userGroupStore).userGroups,
                            striped: "",
                            condensed: "",
                            class: "mt-4",
                            isBusy: (0, vue_2.unref)(userGroupStore).loading
                        }, {
                            "cell-actions": (0, vue_2.withCtx)(({ item: userGroup }) => [
                                (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                                    checked: userGroupChecked(userGroup),
                                    onChange: checked => { userGroupCheckboxChange(checked, userGroup); }
                                }, null, 8, ["checked", "onChange"])
                            ]),
                            _: 1
                        }, 8, ["fields", "items", "isBusy"]),
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary",
                                onClick: _cache[14] || (_cache[14] = ($event) => (selectedUser.value === null ? createUser() : updateUser()))
                            }, [
                                _hoisted_17,
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "users")), 1)
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
